module.exports = __webpack_public_path__ + "img/shanghai_early.3c308439.jpg";